document.addEventListener('DOMContentLoaded', function() {
    const individualDeliveryDateContainer = document.getElementById('individual_delivery_date');
    const customBulletpoints = document.querySelectorAll('.individual_delivery_date.custom_bulletpoint');

    function getVariantIdFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('variant');
    }

    function getFirstVariantId() {
        return customBulletpoints.length > 0 ? customBulletpoints[0].getAttribute('data-variant-id') : null;
    }

    function toggleVariantElements() {
        let variantId = getVariantIdFromUrl();
        if (!variantId) {
            variantId = getFirstVariantId();
        }

        let isVisible = false;

        customBulletpoints.forEach(element => {
            if (element.getAttribute('data-variant-id') === variantId) {
                element.style.display = 'block';
                isVisible = true;
            } else {
                element.style.display = 'none';
            }
        });

        individualDeliveryDateContainer.style.display = isVisible ? 'block' : 'none';
    }

    // Initial check
    toggleVariantElements();

    // Listen for URL changes using MutationObserver
    const observer = new MutationObserver(toggleVariantElements);

    observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['href']
    });

    // Update display when the popstate event is triggered (e.g., browser back/forward buttons)
    window.addEventListener('popstate', toggleVariantElements);

    // Update display when the URL changes due to history pushState/replaceState
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;
    history.pushState = function() {
        originalPushState.apply(this, arguments);
        toggleVariantElements();
    };
    history.replaceState = function() {
        originalReplaceState.apply(this, arguments);
        toggleVariantElements();
    };
});

/*
function startCountdown(startDateStr) {
    // Convert the start date string to a timestamp
    var startDate = new Date(startDateStr).getTime();

    // Set the countdown time to 48 hours from the start date
    var countdownTime = startDate + (48 * 60 * 60 * 1000);

    // Update the countdown every second
    var countdownInterval = setInterval(function() {
        var now = new Date().getTime();
        var distance = countdownTime - now;

        // Time calculations for hours, minutes, and seconds
        var hours = Math.floor((distance % (1000 * 60 * 60 * 48)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Display the result in the element with id="countdown"
        document.getElementById("countdown").innerHTML = hours + "h " 
        + minutes + "m " + seconds + "s ";

        // If the countdown is over, display a message
        if (distance < 0) {
            clearInterval(countdownInterval);
            document.getElementById("countdown").innerHTML = "EXPIRED";
        }
    }, 1000);
}


// Call the function with the desired start date
startCountdown('2024-09-23T06:00:00'); // Example start date
*/


function startCountdownTimer(startDate, endDate, displayElementId) {
    // Parse the start and end dates
    const start = new Date(startDate).getTime();
    const end = new Date(endDate).getTime();
    const displayElement = document.getElementById(displayElementId);

    // Check if dates are valid
    if (isNaN(start) || isNaN(end)) {
        console.error("Timer nicht korrekt konfiguriert");
        return;
    }

    // Ensure the timer runs only if the current date is between start and end dates
    function updateTimer() {
        const now = new Date().getTime();

        // Calculate remaining time based on the end date
        const remainingTime = end - now;

        // Stop the timer if the end date is reached
        if (remainingTime <= 0) {
            displayElement.textContent = "Timer abgelaufen";
            clearInterval(timerInterval);
            return;
        }

        // Calculate time components
        const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
        const hours = Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

        // Display the countdown timer in the specified element
        displayElement.textContent = `${days} : ${hours} : ${minutes} : ${seconds}`;
    }

    // Check if current time is within the start and end range
    if (new Date().getTime() >= start && new Date().getTime() < end) {
        // Update the timer immediately, then set the interval
        updateTimer();
        var timerInterval = setInterval(updateTimer, 1000);
    }
}
// Example: startCountdownTimer("2024-10-01T00:00:00", "2024-12-31T23:59:59", "timerDisplay");
startCountdownTimer("2024-10-30T12:00:00", "2024-11-01T00:00:00", "timerDisplay");


function stylePreorderButton() {
    // Function to update styles for 'product-form__submit' and its child span.txt
    const updateButtonStyles = () => {
        // Select all elements with the class 'product-form__submit'
        const submitButtons = document.querySelectorAll('.product-form__submit');

        submitButtons.forEach(button => {
            // Check if there is a span with the class 'txt' inside the button
            const txtSpan = button.querySelector('span.txt');
            
            if (txtSpan) {
                if (txtSpan.textContent.trim() === 'Vorbestellen') {
                  // Apply the background color to the button
                  button.style.backgroundColor = '#C92C23';
                  button.style.border = '1px solid #C92C23';

                  // Apply additional styles to the span with class 'txt'
                  txtSpan.style.color = '#fff';
                  
                } else {
                  // Remove the styles if 'Vorbestellen' is not found
                  button.style.backgroundColor = '';
                  button.style.border = '';
                  txtSpan.style.color = '';
                  
                }
            }
        });
    };

    // Run the update function initially
    updateButtonStyles();

    // Create a MutationObserver to handle dynamically loaded elements or changes
    const observer = new MutationObserver(updateButtonStyles);

    // Start observing changes to the document
    observer.observe(document.body, { childList: true, subtree: true });
}

// Call the function to apply the functionality
stylePreorderButton();


function initHideUpcartTitles() {
  function hideUpcartTitles() {
    document.querySelectorAll('.upcart-upsells-title').forEach(function(el) {
      el.style.display = 'none';
    });
  }
  
  // Direkt vorhandene Elemente ausblenden
  hideUpcartTitles();
  
  // MutationObserver einrichten, um neu hinzugefügte Elemente zu erfassen
  const observer = new MutationObserver(function(mutations) {
    hideUpcartTitles();
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', initHideUpcartTitles);



